export enum ExternalMemberLinkMode {
  NONE = 0,
  REGISTER = 1,
  LOGIN = 2
}
